<template>
  <form>
    <LoginTextField
      :autocomplete="false"
      autoFocus
      @input="handleInput"
      :label="label"
      :maxlength="6"
      :placeholder="placeholder"
      required
      :submitOnEnter="handleSubmit"
      :value="token"
      vvName="verification code"
    />
    <LoginActionButton
      :action="handleSubmit"
      :disabled="isDisabled"
      :isLoading="isLoading"
    >
      {{ buttonText }}
    </LoginActionButton>
    <div
      :class="$style.resetPassword"
      v-if="shouldShowTOTPResetLink"
    >
      <span
        :class="{
          [$style.resetPasswordLink]: true,
          [$style.fadeTransition]: true,
          [$style.fadeTo]: isLoadingReset
        }"
        @click="handleResetTOTP"
      >
        Lost your TOTP device?
      </span>
      <transition
        :enterClass="$style.fadeTo"
        :enterActiveClass="$style.fadeTransition"
        :leaveActiveClass="$style.fadeTransition"
        :leaveToClass="$style.fadeTo"
      >
        <div
          v-if="isLoadingReset"
          :class="$style.loadingIconContainer"
        >
          <LoadingIcon />
        </div>
      </transition>
    </div>
  </form>
</template>

<script>
// Components
import LoadingIcon from 'components/LoadingIcon.vue';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginTextField from 'client/components/LoginTextField.vue';

export default {
  name: 'LoginInputConfirmation',

  computed: {
    isDisabled() {
      return this.token.length < 6;
    },
  },

  data: () => ({
    isLoadingReset: false,
  }),

  props: {
    buttonText: {
      type: String,
      default: 'Login',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Verification Code',
    },
    token: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Enter code from your mobile authenticator app:',
    },
    shouldShowTOTPResetLink: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    LoadingIcon,
    LoginActionButton,
    LoginTextField,
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
    handleSubmit(e) {
      this.$emit('onSubmit', e);
    },
    handleResetTOTP(e) {
      this.isLoadingReset = true;
      this.$emit('onRequestReset', e);
    },
  },
};
</script>

<style module>
@import '../../css/login-components.css';

.resetPassword {
  position: relative;
}

.loadingIconContainer {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1.5em;
}

.fadeTransition {
  transition: opacity 0.2s ease-in-out;
}

.fadeTo {
  opacity: 0;
}
</style>
